import Vue from 'vue'

import {
  AddressbarColor,
  ClosePopup,
  QAvatar,
  QBtn,
  QIcon,
  QInput,
  QItem,
  QItemLabel,
  QItemSection,
  QPopupProxy,
  QRadio,
  QSelect,
  QStep,
  QStepper,
  QTooltip,
  Quasar,
  QVirtualScroll,
  QList,
} from 'quasar'

import '@/styles/quasar.styl'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/roboto-font/roboto-font.css'

Vue.use(Quasar, {
  components: {
    QInput,
    QIcon,
    QBtn,
    QStepper,
    QStep,
    QTooltip,
    QSelect,
    QRadio,
    QItemSection,
    QItem,
    QItemLabel,
    QVirtualScroll,
    QPopupProxy,
    QAvatar,
    QList,
  },
  plugins: {
    AddressbarColor,
  },
  directives: {
    ClosePopup,
  },
})
